import React from 'react';

import { IconButton } from '@mui/material';
import type { IconButtonProps } from '@mui/material';
import { Upload } from 'lucide-react';

import { AlineTooltip } from './AlineTooltip';

interface UploadIconButtonProps extends Omit<
  IconButtonProps,
  'children' | 'color' | 'size' | 'sx'
> {
  tooltip: string;
  appearance?: 'filled' | 'outlined';
}

export const UploadIconButton = React.forwardRef<HTMLButtonElement, UploadIconButtonProps>(
  function UploadIconButton(props, ref) {
    const { appearance = 'outlined', tooltip, ...buttonProps } = props;

    return (
      <AlineTooltip arrow placement="top" title={tooltip}>
        <IconButton
          ref={ref}
          aria-label={buttonProps['aria-label'] ?? tooltip}
          size="small"
          sx={theme => ({
            ...(appearance === 'filled'
              ? {
                  '&:active, &:hover, &.Mui-focusVisible': {
                    color: theme.palette.common.white,
                  },
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.common.white,
                }
              : {
                  '&:hover': { backgroundColor: theme.appColors.hoverBackground },
                  border: `1px solid ${theme.appColors.rule}`,
                }),
            height: 32,
            width: 32,
          })}
          {...buttonProps}
        >
          <Upload size={18} />
        </IconButton>
      </AlineTooltip>
    );
  }
);
